import React from 'react'
import Header from "../components/header/header";
import ContentWriting from "../sections/ContentWriting/ContentWriting"
import Footer from "../components/footer/footer";

function Contentwriting() {
    return (
        <>
            <Header />
            <ContentWriting />
            <Footer />
        </>
    )
}

export default Contentwriting
